exports.SignIn = {
  path: '/signin',
  name: 'SignIn'
}
